<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle>
      {{ dialogData.title || "unsaved-changes-modal.title" | translate }}
    </h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="continueEditing()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <p>
      {{ dialogData.message || "unsaved-changes-modal.message" | translate }}
    </p>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="secondary" (click)="continueEditing()">
      {{ "unsaved-changes-modal.button.continue-editing" | translate }}
    </sui-button>

    <sui-button
      variant="primary"
      [leadingIcon]="['fas', 'save']"
      [disabled]="!dialogData?.isValid()"
      (click)="saveAndClose()"
    >
      {{ "unsaved-changes-modal.button.save-and-close" | translate }}
    </sui-button>

    <sui-button
      variant="danger"
      [leadingIcon]="['fas', 'trash']"
      (click)="discardChanges()"
    >
      {{ "unsaved-changes-modal.button.discard-changes" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
